export default {
    computed: {
        isClipboardEmpty() {
            return this.$store.state.clipboard.item === null;
        },
        clipboardBlock() {
            return this.$store.state.clipboard.item;
        }
    }
}
